const originURL = new URL(process.env.ORIGIN ?? window.origin)

export const host = originURL.host

export const hostname = originURL.hostname

export const BASE_FILE_PATH = 'staticFiles/images'

export const BASE_MEDIA_PATH = 'staticFiles/media'

export const FILE_PATH = {
  // 测试用
  UPLOAD_TEST: `${BASE_FILE_PATH}/test`,
  // 机构设置-系统 logo
  SYSTEM_LOGO: `${BASE_FILE_PATH}/logo/system`,
  // 机构设置-健康评估报告 logo
  REPORT_LOGO: `${BASE_FILE_PATH}/logo/report`,
  // 员工管理-员工头像
  AVATAR_PIC: `${BASE_FILE_PATH}/user/avatar`,
  // 等级管理-等级图标
  VIP_LEVEL_PIC: `${BASE_FILE_PATH}/customer/vipLevel/upload`,
  // 客户管理-客户头像
  CUSTOMER_AVATAR: `${BASE_FILE_PATH}/customer/avatar`,
  // 套餐详情图片
  SERVICE_PACKAGE_DETAIL: `${BASE_FILE_PATH}/service/package/detail`,
  // 任务处理图片上传
  SERVICE_TASK_PROCESS: `${BASE_FILE_PATH}/task/process`,
  // 任务处理凭证
  SERVICE_TASK_PROCESS_PROOF: `${BASE_FILE_PATH}/task/proof`,
  // 商城图片
  MALL_SHOP: `${BASE_FILE_PATH}/mall/shop`,
  // 商品图片
  MALL_COMMODITY: `${BASE_FILE_PATH}/mall/commodity`,
  //
  ORDER_ADMINISTRATE: `${BASE_FILE_PATH}/order/administrate`,
  // 用药记录图片
  MEDICATION_RECORDS: `${BASE_FILE_PATH}/customer/detail/medicationRecords`,
  // 体检记录图片
  EXAM_RECORDS: `${BASE_FILE_PATH}/customer/detail/examRecords`,
  // 体检报告图片
  UPLOAD_REPORT: `${BASE_FILE_PATH}/customer/uploadReport`,
  // 知识库-药品图片
  CONTENT_MEDICINE: `${BASE_FILE_PATH}/content/medicine`,
  // 知识库-干预方案图片
  CONTENT_INTERVENTION: `${BASE_FILE_PATH}/content/intervention`,
  CONTENT_SPORT: `${BASE_FILE_PATH}/content/sport`,
  // 咨询聊天图片
  INQUIRY_IMAGE: `${BASE_FILE_PATH}/inquiry/message`,
  // 富文本上传图片
  TINY_MCE_IMAGES: `${BASE_FILE_PATH}/tinymce/images`,

  TINY_MCE_MEDIA: `${BASE_FILE_PATH}/tinymce/media`,
  // 用户满意度问卷
  CUSTOMER_ASSESSMENT: `${BASE_FILE_PATH}/customer/assessment`,
  // 资讯音视频
  INFORMATION_MEDIA: `${BASE_MEDIA_PATH}/information`,
  // 自定义页面配置
  CUSTOMIZATION_PAGE: `${BASE_FILE_PATH}/customization`,
  // 菜品图片
  DISHES_PIC: `${BASE_FILE_PATH}/dishes`,
  HOMEPAGE_DECORATION: `${BASE_FILE_PATH}/homepage`, // 首页装修
  // 营养素图片
  NUTRIMENT_PIC: `${BASE_FILE_PATH}/nutriment`,
  // 医疗服务管理
  MEDICAL_FUNCTION: `${BASE_FILE_PATH}/medical`,
  // 商品订单
  GOODS_ORDER: `${BASE_FILE_PATH}/goods_order`,
  // 商品订单
  GOODS_PDF: `${BASE_FILE_PATH}/goods_pdf`,
  // 耗材图片
  SUPPLY_PIC: `${BASE_FILE_PATH}/goods_pdf`,
  // 检测项目图片
  FUNCTIONAL_MEDICINE_PIC: `${BASE_FILE_PATH}/goods_pdf`,
  // 慢性食物敏感分析智能识图
  CHRONIC_FOOD_INTOLERANCE_OCR: `${BASE_FILE_PATH}/chronic_food_intolerance_ocr`,
  // 活动图片
  ACTIVITY_PIC: `${BASE_FILE_PATH}/chronic_food_intolerance_ocr`,
}

export const WSS_URL = `wss://message.${host}/stream`

export const UPLOAD_URL = `https://${host}/api/core/file/user`
